/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';
import CSSTransition from 'react-transition-group/CSSTransition';
import classNames from 'classnames';
import $ from 'jquery';

import './slideout.scss';

class Slideout extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		this._bindUnbindEvents();

		const cNames = classNames({
			'explore__slideout': true,
			'explore__slideout--fullHeight': this.props.fullHeight
		});

		return (
			<CSSTransition
				in={this.props.active}
				classNames={this.props.className}
				timeout={this.props.timeout}
				appear={true}
				mountOnEnter={true}
				unmountOnExit={true}>
				<div className={cNames}>
					{this.props.children}
				</div>
			</CSSTransition>
		);
	}

	componentWillUnmount() {
		this._unbindEvents();

		// Trigger the on close even when this component unmounts.
		// This allows the consuming component to update the model to reflect the closed state.
		this.props.onClickOutside();
	}

	_handleOutsideClick(event) {
		if (!$(event.target).closest('.explore__slideout').length) {
			this.props.onClickOutside();
		}
	}

	_bindEvents() {
		if (!this._outsideClickListener) {
			this._outsideClickListener = this._handleOutsideClick.bind(this);

			document.addEventListener('mousedown', this._outsideClickListener);
			document.addEventListener('touchstart', this._outsideClickListener);
		}
	}

	_unbindEvents() {
		if (this._outsideClickListener) {
			document.removeEventListener('mousedown', this._outsideClickListener);
			document.removeEventListener('touchstart', this._outsideClickListener);

			this._outsideClickListener = null;
		}
	}

	_bindUnbindEvents() {
		if (this.props.active) {
			this._bindEvents();
		} else {
			this._unbindEvents();
		}
	}
}

Slideout.propTypes = {
	active: PropTypes.bool,
	timeout: PropTypes.number,
	fullHeight: PropTypes.bool,
	className: PropTypes.string,
	children: PropTypes.any,
	onClickOutside: PropTypes.func
};
Slideout.defaultProps = {
	active: true,
	timeout: 400,
	fullHeight: false,
	className: '',
	children: [],
	onClickOutside: () => {}
};
export default Slideout;



// WEBPACK FOOTER //
// ./src/js/components/transition/Slideout.js